/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  Pne,
  SearchService,
} from 'src/app/shared/services/metadata-api/search.service';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, map, shareReplay, catchError } from 'rxjs/operators';
import {
  MatLegacyDialog as MatDialog,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { AuthService } from '../../../../service/auth.service';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-portfolio-index',
  templateUrl: './portfolio-index.component.html',
  styleUrls: ['./portfolio-index.component.scss'],
})
export class PortfolioIndexComponent {
  step = 0;
  myIndex: UntypedFormControl = new UntypedFormControl();
  aggregatedPortfolios = [];
  items$: Observable<string[]>;
  itemsPNE: Pne[] = [];
  loadingPNE: boolean;
  indexmap: string;
  params: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private searchService: SearchService,
    public auth: AuthService,
    public portfolioApi: PortfolioApiService,
    private router: Router,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
  ) {
    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });

    if (this.portfolioApi.activePortfolio.is_aggregated) {
      if (this.data.action === 'new') {
        this.portfolioApi.getAggregatedPortfolios().subscribe((res) => {
          this.aggregatedPortfolios = res.hits.filter(
            (el) => el.uid === this.portfolioApi.activePortfolio.uid,
          )[0].content;
        });
      }
    }

    this.myIndex.valueChanges.pipe(debounceTime(1000)).subscribe((value) => {
      if (value && value.length > 1) {
        this.loadingPNE = true;
        const reqEntity = this.searchService.search(value, this.params).pipe(
          map((res) => res),
          catchError(() => of({ hits: [] })),
        );
        const reqPNE = this.searchService
          .searchPne(value, this.params)
          .pipe(catchError(() => of([] as Pne[])));
        this.items$ = reqEntity.pipe(
          map((res) => {
            reqPNE.subscribe((pneRes) => {
              this.itemsPNE = pneRes;
              this.loadingPNE = false;
            });
            return res.hits;
          }),
          shareReplay(),
        );
      } else {
        this.loadingPNE = false;
      }
    });

    if (this.data.action === 'edit') {
      this.myIndex.setValue(this.data.entity.name);
    }
  }

  goSelect(value) {
    if (value.type === 'pne') {
      this.myIndex.setValue(value.pne.surface);
      this.indexmap = 'pne:' + value.pne.alpha_id;
    } else {
      this.myIndex.setValue(value.entity.name);
      this.indexmap = value.entity.type + ':' + value.entity.alpha_id;
    }
  }

  saveIndex() {
    if (this.indexmap) {
      if (this.data.action === 'new') {
        if (
          this.portfolioApi.activePortfolio &&
          this.portfolioApi.activePortfolio.content.length + 1 >
            this.auth.featureFlags.entitiesPerPortfoliosLimit
        ) {
          this.snackBar.open(
            'Number of entities per portfolio is limited to ' +
              this.auth.featureFlags.entitiesPerPortfoliosLimit +
              '.',
            'OK',
            { duration: 5000 },
          );
        } else {
          this.portfolioApi.addEntity([this.indexmap]).subscribe(() => {
            this.router.navigate([], {
              queryParams: {
                update: Math.random(),
              },
              queryParamsHandling: 'merge',
            });
            this.dialog.closeAll();
          });
        }
      }
      if (this.data.action === 'edit') {
        const value = this.data.entity.type + ':' + this.data.entity.alpha_id;
        this.portfolioApi.deleteEntity(value).subscribe(() => {
          this.portfolioApi.addEntity([this.indexmap]).subscribe(() => {
            this.router.navigate([], {
              queryParams: {
                update: Math.random(),
              },
              queryParamsHandling: 'merge',
            });
            this.dialog.closeAll();
          });
        });
      }
    }
    if (this.portfolioApi.activePortfolio.is_aggregated) {
      if (this.data.action === 'new') {
        this.portfolioApi
          .aggregatePortfolios(
            this.aggregatedPortfolios,
            this.portfolioApi.activePortfolio.uid,
          )
          .subscribe(() => {
            this.router.navigate([], {
              queryParams: {
                update: Math.random(),
              },
              queryParamsHandling: 'merge',
            });
            this.dialog.closeAll();
          });
      }
    }
  }

  deleteIndex() {
    const value = this.data.entity.type + ':' + this.data.entity.alpha_id;
    this.portfolioApi.deleteEntity(value).subscribe(() => {
      this.router.navigate([], {
        queryParams: {
          update: Math.random(),
        },
        queryParamsHandling: 'merge',
      });
      this.dialog.closeAll();
    });
  }

  /**
   *
   */
  iMatch(entity) {
    if (entity.matched_form) {
      return (
        entity.name.charAt(0).toLowerCase() !== entity.matched_form.charAt(0)
      );
    }
  }

  /**
   * format big numbers >999 into K, M, ...
   */
  numberFormat(num: number) {
    const formatter = new Intl.NumberFormat('en', { notation: 'compact' });
    return formatter.format(num);
  }
}
